<template>
  <Row>
    <Col span="24">
    <Card>
      <p slot="title">数据表单列表</p>
      <span slot="extra">
        <Select v-model="status" style="width:120px" @on-change="fetchData" placeholder="请选择状态" clearable>
          <Option v-for="(status,key) in statuses" :value="key" :key="key">{{ status }}</Option>
        </Select>
        <Input v-model="queryStr" placeholder="请输入关键词查询" @on-change="fetchData" style="width: 300px"></Input>
        <Button type="success" @click="showAdd = true"><Icon type="plus"></Icon> 添加</Button>
      </span>
      <Table stripe :columns="attributes" :data="domains" v-if="domains">
        <template slot-scope="{ row }" slot="repeated">
            <span v-if="row.repeated === 1">
              <Tag color="success">是</Tag>
            </span>
        </template>
      </Table>
      <pagination v-bind:meta="pageMeta" name="pagination" @refresh="fetchData"></pagination>
    </Card>
    <Modal
        v-model="showAdd"
        title="添加数据表单"
        :styles="{bottom:'0px'}" >
        <add-domain ref="addDomain" @refresh="refresh"></add-domain>
        <div slot="footer" v-show="false"></div>
    </Modal>
    <Modal
        v-model="showEdit"
        title="编辑数据表单信息"
        :styles="{bottom:'0px'}" >
        <edit-domain ref="editDomain" :meta="meta" @refresh="refresh"></edit-domain>
        <div slot="footer" v-show="false"></div>
    </Modal>
    <Modal
        v-model="showVariables"
        title="变量列表" :fullscreen="true"
        :footer-hide="true" >
        <list-vars ref="listVars" :domainid="domainid"></list-vars>
        <div slot="footer" v-show="false"></div>
    </Modal>
    </Col>
  </Row>
</template>

<script>
import { ListDomains, DeleteDomain } from '@/api/domain'
import AddDomain from '@/components/domain/AddDomain'
import EditDomain from '@/components/domain/EditDomain'
import ListVariables from '@/views/design/ListVariables'
import Pagination from '@/components/share/Pagination'

export default {
  name: 'list-domains',
  data: function () {
    return {
      domains: [],
      queryStr: '',
      meta: '',
      domainid: '',
      showAdd: false,
      showEdit: false,
      showVariables: false,
      pageMeta: {},
      status: '1',
      statuses: {
        '1': '激活',
        '0': '禁用'
      },
      attributes: [{
        title: '表单名称',
        key: 'domain',
        sortable: true
      },
      {
        title: '表单标签',
        key: 'label',
        sortable: true
      },
      {
        title: '多条记录',
        key: 'repeated',
        sortable: true,
        slot: 'repeated'
      },
      {
        title: '填写说明',
        key: 'instructions'
      },
      {
        title: '状态',
        key: 'statusText'
      },
      {
        title: '操作',
        key: 'action',
        width: 120,
        render: (h, params) => {
          const icon = params.row.status === 1 ? 'ios-trash' : 'ios-refresh'
          return h('div', [
            h('Button', {
              props: {
                type: 'text',
                size: 'small',
                icon: 'ios-create-outline'
              },
              on: {
                click: () => {
                  this.edit(params.row.id)
                }
              }
            }),
            h('Button', {
              props: {
                type: 'text',
                size: 'small',
                icon: icon
              },
              on: {
                click: () => {
                  this.remove(params.row.id)
                }
              }
            }),
            h('Button', {
              props: {
                type: 'text',
                size: 'small',
                icon: 'ios-apps'
              },
              on: {
                click: () => {
                  this.showVars(params.row.id)
                }
              }
            })
          ])
        }
      }]
    }
  },
  components: {
    'pagination': Pagination,
    'add-domain': AddDomain,
    'edit-domain': EditDomain,
    'list-vars': ListVariables
  },
  created: function () {
    this.fetchData()
  },
  methods: {
    fetchData: function (page = 1) {
      var query = this.$router.currentRoute.query
      query['page'] = page
      query['DomainSearch[status]'] = this.status
      query['DomainSearch[studyid]'] = this.$route.params.id
      query['queryStr'] = this.queryStr
      ListDomains(query).then(async res => {
        this.domains = res.items
        this.pageMeta = res._meta
      })
    },
    refresh: function () {
      this.fetchData()
      this.showAdd = false
      this.showEdit = false
      this.showVariables = false
    },
    edit: function (id) {
      this.meta = id
      this.$refs.editDomain.init(id)
      this.showEdit = true
    },
    remove: function (id) {
      DeleteDomain(id).then(async res => {
        this.refresh()
      })
    },
    showVars: function (id) {
      this.domainid = id
      this.$refs.listVars.fetchData()
      this.showVariables = true
    }
  }
}
</script>
